import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Inbox from './Inbox';
import Content from './Content';
import ModalConfirmContainer from './ModalConfirmContainer';
import {
  Header,
  CaseSpecimenPortal,
  SpecimenFormContainer,
  Aox,
} from '../components';
import {
  getCases,
  hideConfirmModal,
  getAllPathologists,
  getValidationSpecimens,
  selectPathologist,
} from '../redux/actions';
import InboxValidation from './InboxValidation';
import { userRoles } from '../constants';
import Notification from './Notification';

const Wrapper = styled.div`
  display: flex;
  width: 100vw;
  flex-wrap: wrap;
`;

class Main extends PureComponent {
  constructor(props) {
    super(props);
    const isValidationStudy = this.props.user.role === userRoles.val_pathologist;
    isValidationStudy && this.props.selectPathologist(this.props.user);

    this.state = {
      showPortal: true,
      isValidationStudy,
      portalConnected: false,
      timeoutTriggered: false,
      sidebarHidden: false,
      mainClass: isValidationStudy ? 'validation__main' : 'main',
    };
  }

  componentDidMount() {
    const { isValidationStudy } = this.state;
    const { user, getAllPathologists, getValidationSpecimens, getCases } = this.props;
    if (isValidationStudy) {
      getValidationSpecimens(user._id);
    } else {
      getCases(user, false);
      if (user.role === userRoles.surgeon || user.role === userRoles.admin) {
        getAllPathologists();
      }
    }

    window.onunload = () => {
      this.setState({ showPortal: false, portalConnected: false });
    };
  }

  connectPortal = () => {
    this.setState({ portalConnected: true });
  };

  timeoutFunc = () => {
    setTimeout(this.connectPortal, 1);
    this.setState({ timeoutTriggered: true });
  };

  closeWindowPortal = () => {
    this.setState({ timeoutTriggered: false, portalConnected: false });
  };

  handlePortalContent = () => {
    /*    let style = {};
        if (!this.state.portalConnected) {
          style = { display: 'none' };
            }
    */
    if (!this.state.timeoutTriggered) {
      this.timeoutFunc();
    }

    if (this.props.selectedSpecimen._id) {
      return (
        <Aox>
          <SpecimenFormContainer />
        </Aox>
      );
    }

    /* Portal when no specimen is selected/ resting portal screen: */
    return (
      <div style={{ background: '#ededed', minHeight: '100%' }}>
        <div style={{ background: '#8080be' }}>
          <p style={{
            fontFamily: 'sans-serif', fontSize: '1.5em', color: '#ffffff', padding: '0.5em', 'letter-spacing': '1px',
          }}
          >
            CADESS

          </p>
        </div>
        <p style={{
          fontFamily: 'sans-serif', fontSize: '2em', color: '#000000', padding: '3em', textAlign: 'center',
        }}
        >
          Please select a specimen

        </p>
      </div>
    );
  };

  handleCollapse = () => {
    const { isValidationStudy, mainClass } = this.state;
    if (isValidationStudy) {
      if (mainClass === 'validation__main') {
        this.setState({ mainClass: 'validation__main-collapsed' });
      } else {
        this.setState({ mainClass: 'validation__main' });
      }
    } else if (mainClass === 'main') {
      this.setState({ mainClass: 'main-collapsed' });
    } else {
      this.setState({ mainClass: 'main' });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Header />
        <Wrapper>
          <Notification />
          {this.state.isValidationStudy
            ? (
              <InboxValidation
                handleMainCollapse={this.handleCollapse}
              />
            )
            : (
              <Inbox
                handleMainCollapse={this.handleCollapse}
              />
            )
          }
          <Content mainClass={this.state.mainClass} isValidation={this.state.isValidationStudy} />

          {(this.props.portalActive && this.state.showPortal) && (
            <CaseSpecimenPortal closeWindowPortal={this.closeWindowPortal}>

              <div onClick={() => console.log('initializing portal')}>
                {this.handlePortalContent()}
              </div>

            </CaseSpecimenPortal>
          )}
          <ModalConfirmContainer onClose={this.props.hideConfirmModal} />
        </Wrapper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    selectedCase,
    selectedSpecimen,
    showForm,
    portalActive,
    currentPathologist,
  } = state._case;

  const {
    snapshots,
    snapshotActive,
    tempSnapshot,
  } = state.snapshot;

  const { user } = state.auth;
  return {
    currentPathologist,
    user,
    selectedCase,
    selectedSpecimen,
    snapshots,
    snapshotActive,
    tempSnapshot,
    showForm,
    portalActive,
  };
};

Main.propTypes = {
  getCases: PropTypes.func.isRequired,
};


export default connect(mapStateToProps, {
  getCases,
  hideConfirmModal,
  getAllPathologists,
  getValidationSpecimens,
  selectPathologist,
})(Main);
